import React from 'react';
import Image from 'next/image';

import Breadcrumb from '../common/seo/BreadCrumbs';
import Button from '../ui/components/Button';

const HeroSection = ({ examData, handleOpen, breadcrumbItems, exam_title }: any) => {
  return (
    <section className="relative h-full">
      <div className="relative">
        <Image
          src={examData?.banner?.[0]?.url}
          alt={examData?.exam_name ?? 'default_exam'}
          width={1520}
          height={288}
          className="h-60 w-full object-fill object-center md:h-[21rem]"
          quality={50}
          blurDataURL="blur"
          priority
          loading="eager"
        />
        <div className="absolute inset-0 h-60 bg-black/75 md:h-[21rem] md:bg-black/50"></div>

        <div className="absolute inset-0 flex flex-col px-2 pt-14 text-white lg:mx-auto lg:max-w-screen-xl lg:px-4 lg:pt-[5.5rem]">
          <div className="ml-2">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <div className="flex gap-4">
            <div className="mt-2 size-16 max-h-16 max-w-16 rounded bg-white p-1 md:max-h-24 md:max-w-24 lg:size-24">
              <Image
                width={200}
                height={200}
                alt={examData?.exam_name ?? 'Exam Logo'}
                src={examData?.logo?.url}
                className="size-full object-fill object-center"
                priority
              />
            </div>
            <div className="flex flex-1 flex-col gap-3">
              <div className="flex items-center gap-4">
                <h1 className="text-sm font-semibold sm:text-lg md:font-bold lg:text-2xl">
                  {examData?.exam_name} : {exam_title}
                </h1>
              </div>
              {examData?.exam_mode?.exam_mode && (
                <div className="hidden items-center gap-2 md:flex">
                  <div>Exam Mode :</div>
                  <div className="flex items-center gap-2">
                    <div className="w-fit rounded-lg bg-white px-2 text-sm text-black ">
                      {examData?.exam_mode?.exam_mode}
                    </div>
                  </div>
                </div>
              )}

              <div className="mr-2 mt-7 hidden justify-end gap-4 text-white md:flex">
                <div>
                  <Button
                    onClick={() => handleOpen(examData?.id, examData?.abbreviation)}
                    text={'Register Now'}
                    outline
                    outlineColor="border-white"
                    textColor="text-white"
                    paddingX="px-[2px] md:px-[10px]"
                    paddingY="py-[6px] md:py-[10px]"
                    width="w-26 md:w-36"
                    align="text-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
